import { ref } from 'vue'

const isOnline = ref(typeof navigator !== 'undefined' ? navigator.onLine : true)
const wasOffline = ref(false)
let listenersBound = false

function handleOnline() {
  const wasOfflineBefore = !isOnline.value
  isOnline.value = true
  if (wasOfflineBefore) {
    wasOffline.value = true
    setTimeout(() => {
      wasOffline.value = false
    }, 1000)
  }
}

function handleOffline() {
  isOnline.value = false
}

function ensureListeners() {
  if (listenersBound || typeof window === 'undefined') return
  listenersBound = true
  window.addEventListener('online', handleOnline)
  window.addEventListener('offline', handleOffline)
}

/**
 * Shared online/offline status for the whole app (module-level singleton).
 */
export function useConnectionStatus() {
  ensureListeners()
  return {
    isOnline,
    wasOffline,
  }
}
